import { useRouter } from 'next/router'
import { useState } from 'react'

import CampaignAuthButtons from '~/shared/campaign/CampaignAuthButtons'
import { CampaignContent } from '~/shared/campaign/Campaign.types'
import GuestGuard from '~/components/GuestGuard'
import { TermsAndConditions } from '~/auth/components/TermsAndConditions'

const style: React.CSSProperties = {
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  backgroundColor: '#FFFFFF',
  borderRadius: '11px',
  outline: 'none',
  zIndex: 100000,
  maxWidth: '90%',
}

function SSOCampaignCard({ campaignContent }: { campaignContent: CampaignContent }): React.ReactElement {
  const [showClickText, setShowClickText] = useState(false)
  const { title, subtitle, clickText } = campaignContent
  const parts = useRouter().asPath.split('/')

  const onBackgroundClick = (): void => {
    if (!clickText || showClickText) return
    setShowClickText(true)
    setTimeout(() => {
      setShowClickText(false)
    }, 5000)
  }

  const redirectPage = parts.filter((part) => part !== 'campaigns').join('/')
  if (!parts.some((part) => part === 'campaigns')) return <></>

  return (
    <GuestGuard redirect={redirectPage}>
      <meta content="noindex" name="robots" />
      <span
        className="bg-gray-medium opacity-70 overflow-y-hidden fixed top-0 right-0 left-0 z-50 inset-0 h-modal h-full"
        onClick={onBackgroundClick}
      />

      <div className="top-1/2" style={style}>
        {clickText && (
          <div
            className={`absolute flex flex-col text-black-light left-0 right-0 m-auto w-full -z-1 bottom-[375px] sm:bottom-87.5 transition duration-500 ${
              showClickText ? '-translate-y-87.5 opacity-100' : 'translate-y-87.5 opacity-0'
            }`}
          >
            <p className="bg-white p-4 rounded-4">{clickText}</p>
            <span className="w-0 h-0 border-l-12 border-solid border-l-transparent border-r-12 ml-4 -mt-0.5 border-r-transparent border-t-12 border-t-white" />
          </div>
        )}
        <div className="bg-white text-black-light p-4 rounded">
          <h1 className="mt-2 text-center text-lg lg:text-3xl font-semibold">{title}</h1>
          <h2 className="my-5 text-center text-lg lg:text-xl font-medium">{subtitle}</h2>
          <CampaignAuthButtons redirectRoute={redirectPage} />

          <TermsAndConditions className="text-black" linkClassName="text-blue-moderate" />
        </div>
      </div>
    </GuestGuard>
  )
}

export default SSOCampaignCard
